import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import "../components/header.css";
import VerifyLogoProps from "../interfaces/MerchantDisplayProps";
import { isCorrectUrl } from "../validationFunctions/urlValidation";
import shoppingCardIcon from "../assets/img/shopping_Card_Icon.svg"
import { IntlContext } from "../utils/IntlContextProvider";
import ThemeToggle from "./ThemeToggle";

let browserLocale = navigator.language;
browserLocale = browserLocale ?? "English";
browserLocale = (browserLocale === "de-DE" || browserLocale === "de") ? "Deutsch" : "English";

const localeOptions = [
  {
    key: "en_US",
    value: "English"
  },
  {
    key: "de_DE",
    value: "Deutsch"
  }
];

const testId = "local option dropdown";

const Header: React.FC<VerifyLogoProps> = ({ merchantLogo, merchantName, uuid }) => {

  const switchLocale = React.useContext(IntlContext);
  const [locale, setLocale] = useState(browserLocale);

  useEffect(() => {
    window.addEventListener('scroll', function () {
      const header = document.querySelector('header');
      if (header) {
        if (window.scrollY > 0) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }
    });
  }, []);

  const displayContent = (
    <div className="logoContainer" data-testid="logoContainer">
      <a href={`/${uuid}`}>
        {isCorrectUrl(merchantLogo) ? (
            <img
              src={merchantLogo}
              alt={merchantName}
              className="merchantLogo"
              data-testid="logo-merchant"
            />
        ) : (
          <img
            src={shoppingCardIcon}
            alt="shoppingCardIcon"
            className="shoppingCardIcon"
            data-testid="logo-payone"
          />
        )}
      </a>
      
    </div>
  );

  const localeDropdown = (
    <div className="d-flex column-gap-5">
      <Dropdown id="lang_dropdown_wrapper" className="localeDropdown volte-medium" onSelect={(eventKey) => eventKey && onlocaleChange(eventKey)}>
        <Dropdown.Toggle
          id="lang_dropdown"     
          data-testid="lang_dropdown"
        >
          {locale}
        </Dropdown.Toggle>
        <Dropdown.Menu
          align="end"
        >
          <div className="dropdown-arrow"></div>
          {localeOptions.map((option) => (
            <Dropdown.Item
              key={option.key}
              eventKey={option.key}
              data-testid={`${testId}-${option.key.toLowerCase()}`}
              active={option.value === locale}
            >
              {option.value}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <div style={{ width: "50px" }}>
        <ThemeToggle />
      </div>
    </div>
  );

  const onlocaleChange = (eventKey: any) => {
    switchLocale ? switchLocale(eventKey) : null;
    eventKey = eventKey === "en_US" ? "English" : eventKey === "de_DE" ? "Deutsch" : "English";
    setLocale(eventKey);
  }

  return (
    <header data-testid="header-info">
      <div className="container headerWrapper">
        {displayContent}
        {localeDropdown}
      </div>
    </header>
  );
};

export default Header;
